import { useEffect } from 'react';

import { useAppDispatch } from '@/store';
import {
  type TLoadingActionType,
  startGlobalLoading,
  stopGlobalLoading
} from '@/store/loading.slice';

type TProps = {
  loadingType?: TLoadingActionType;
};

const SuspenseFallback: React.FC<TProps> = ({ loadingType = 'layout' }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(startGlobalLoading(loadingType));
    return () => {
      dispatch(stopGlobalLoading(loadingType));
    };
  }, [loadingType]);

  return null;
};

export default SuspenseFallback;
